import IconButton from '@anm/components/buttons/IconButton';
import { blueFilter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled, { css } from 'styled-components';

export type BreadcrumbIconButtonProps = {};

export const folderIconHoverStyles = css`
  &:before {
    ${blueFilter};
  }
`;

export const IconButtonWrapper = styled(IconButton)`
  padding: 0;
  display: block;
  background-color: transparent;
  &:before {
    background-size: cover;
    margin: 0;
  }
  &:hover {
    ${folderIconHoverStyles};
  }
`;

const BreadcrumbIconButton: FC<BreadcrumbIconButtonProps> = () => (
  <IconButtonWrapper
    size="small-simple-icon"
    icon="images/dashboard/folder-small.svg"
    variant="no-wrapper-centered"
    iconSize="32x32"
  />
);

export default BreadcrumbIconButton;
